import { API_ROUTE_ADMIN_FEATURE_TERM_OF_SERVICE } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

type FeatureTermOfServiceOriginal = {
  id: number
  featureId: number
  countryId: number
  version: number
  termsOfUse: string
  createdAt: string
  updatedAt: string
}

export const getFeatureTermOfService = (featureId: number) =>
  get<FeatureTermOfServiceOriginal>(
    API_ROUTE_ADMIN_FEATURE_TERM_OF_SERVICE.replace(':featureId', String(featureId)),
    IS_NEW_BACKEND_API
  )
